//统一设置API接口地址
let urls = {
	getAccessToken: `/app-api/system/auth/getAccessToken`,
	chatPage: `/app-api/digital/ai/chat/page`,
	loginUrl:`/app-api/oauth/app/login`,
	chatGreeting: `/app-api/digital/ai/chat/greeting`,
	getAppid: `/app-api/oauth/officialAccount/getAppid`,
	putSayInfo: `/app-api/digital/ai/chat/put`,
	getSayInfo: `/app-api/digital/ai/chat/get`,


	// getHumanRoleList: `/admin-api/digital/human-role/list`,
	// getHumanModelList:`/admin-api/digital/human-model/list`,
	voiceToText:`app-api/digital/ai/chat/voiceToText`,

	


}
export {urls}